import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Chip from '@mui/material/Chip';
import { LibraryIcon, UserGroupIcon } from 'hugeicons-react';
import { ClickAwayListener, Stack, Tooltip, useTheme } from '@mui/material';
import AiUserIcon from '../../../../icons/components/ai-user';
export default function MachineCardChip(_a) {
    var label = _a.label, showTooltip = _a.showTooltip, onClickAway = _a.onClickAway, tooltipContent = _a.tooltipContent, openTooltip = _a.openTooltip, onClickChip = _a.onClickChip;
    var theme = useTheme();
    return (_jsxs(Stack, { flexDirection: 'row', gap: 1, children: [_jsx(Chip, { size: 'small', variant: 'soft', label: label[0], sx: {
                    background: '#919EAB14',
                    '& .MuiChip-label': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        padding: '10px'
                    }
                }, icon: _jsx(AiUserIcon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                        stroke: theme.palette.text.secondary
                    } }) }), _jsx(Chip, { size: 'small', variant: 'soft', label: label[1], sx: {
                    background: '#919EAB14',
                    '& .MuiChip-label': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        padding: '10px'
                    }
                }, icon: _jsx(UserGroupIcon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                        stroke: theme.palette.text.secondary
                    } }) }), showTooltip ? (_jsx(ClickAwayListener, { onClickAway: function (event) {
                    if (onClickAway) {
                        onClickAway(event);
                    }
                }, children: _jsx(Tooltip, { disableFocusListener: true, disableTouchListener: true, disableHoverListener: true, title: tooltipContent, open: !!openTooltip, arrow: true, slotProps: {
                        popper: { disablePortal: false }
                    }, placement: 'top-start', children: _jsx("span", { style: { display: 'inline-block' }, children: _jsx(Chip, { onClick: function (e) {
                                e.stopPropagation();
                                onClickChip && onClickChip();
                            }, size: 'small', variant: 'soft', label: label[2], sx: {
                                background: '#919EAB14',
                                cursor: 'pointer',
                                '& .MuiChip-label': {
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    color: theme.palette.text.secondary,
                                    padding: '10px'
                                }
                            }, icon: _jsx(LibraryIcon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                                    stroke: theme.palette.text.secondary
                                } }) }) }) }) })) : (_jsx(Chip, { size: 'small', variant: 'soft', label: label[2], sx: {
                    background: '#919EAB14',
                    '& .MuiChip-label': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        padding: '10px'
                    }
                }, icon: _jsx(LibraryIcon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                        stroke: theme.palette.text.secondary
                    } }) }))] }));
}
